module.exports = __webpack_public_path__ + "img/10.892b0b26.png";